import React from "react";
import styled from "styled-components";
import CellSlider from "./CellSlider";

export default function MultipleCellSliders( {data, viewMore=true} ) {
return (
    <Container>
        {data.map((d, i) => {
            return (
                <div className="wrapper"  key={i}>
                    <CellSlider data={d} viewMore={viewMore} />
                </div>
        )})}
    </Container>
)};

const Container = styled.div`
position: relative;
height: 100%;
h3 {
margin-left: 50px;
color: black;
}
.wrapper {
    color: black;
}`;